import {
  Component,
  Input,
} from '@angular/core';
import {LookupService} from "../../srvs/lookup";

@Component({
  selector: 'micro-credential-lookup',
  templateUrl: './micro-credential-lookup.component.html'
})
export class MicroCredentialLookupComponent  {

  @Input()
  credentialId:any;

  @Input()
  link:boolean = true;
}
